module.exports = __webpack_public_path__ + "img/virtual-card-banner.b9617729.png";